import type { RouteRecordRaw } from 'vue-router';
export const contractingRoutes: RouteRecordRaw[] = [
  {
    path: 'contracting',
    name: 'contracting',
    component: () => import('../pages/contracting/ContractingPage.vue'),
    meta: { requiresModule: 'contracting' },
  },
];
